export const getPermissions = () => {
  try {
    return JSON.parse(localStorage.getItem("permissions")) || {};
  } catch {
    return {};
  }
};

export const canAccess = (moduleName, actionName) => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  if (user.role === "admin") return true;

  const permissions = getPermissions();

  return Boolean(permissions?.[moduleName]?.[actionName]);
};